module.exports = __webpack_public_path__ + "img/cash-money.98af530f.svg";